var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarlyDelivery300124(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinejoin: "round",
    transform: "translate(2 10)",
    stroke: "#212121",
    strokeWidth: 1.167
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 0h12v11.333H6V0zm12 6h8v5.333h-8V6zM21.333 2 24 6h-6V2z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 10.667,
    cy: 11.333,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#FFF",
    fillRule: "nonzero",
    cx: 22,
    cy: 11.333,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M0 2.667h6M2 5.333h4M4 8h2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarlyDelivery300124);
export default __webpack_public_path__ + "static/media/early-delivery_30_01_24.61915b1dd8b7e47204a17abd43b11bb3.svg";
export { ForwardRef as ReactComponent };